import React, { useState, useRef } from 'react'
import { Button, Col, Icon, Popconfirm, Row, Table, Tag, Input } from 'antd'
import { ButtonEx } from '../../../styles/button.style'
import BrandHeroForm from './BrandHeroForm'
import BrandHeroReceiveForm from './BrandHeroReceiveForm'
import BrandHeroNoteForm from './BrandHeroNoteForm'
import { useDispatch, useSelector } from 'react-redux'
import { useDeepEffect } from '../../../utils/hooks'
import {
  fetchBrandHero,
  saveBrandHero,
  getAllHeroes
} from '../../../modules/brand'
import PreviewImage from '../../../components/PreviewImage'
import { HeroType } from '../../../config'
import Highlighter from 'react-highlight-words'

const BrandHero = ({ brandId }) => {
  const dispatch = useDispatch()
  const initialOptions = {
    brandId: brandId,
    page: 0,
    size: 20,
    keyword: ''
  }
  const [visible, setVisible] = useState(false)
  const [visiblePreview, setVisiblePreview] = useState(false)
  const [visibleReceive, setVisibleReceive] = useState(false)
  const [noteHero, setNoteHero] = useState(null)
  const [previewImage, setPreviewImage] = useState(null)
  const [formState, setFormState] = useState(null)
  const [formData, setFormData] = useState({})
  const [filterOption, setFilterOption] = useState(initialOptions)
  let searchInput = useRef(null)
  const [searchText, setSearchText] = useState('')

  const { brandHeroList, isLoading } = useSelector(
    (state) => ({
      brandHeroList: state.brand.brandHeroList,
      isLoading: state.brand.isLoading
    }),
    []
  )

  async function fetchData() {
    await dispatch(fetchBrandHero(brandId))
  }

  useDeepEffect(() => {
    fetchData()
  }, [])

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            searchInput = node
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}>
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select())
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text.toString()}
      />
    )
  })

  const handleSearch = (selectedKeys, confirm) => {
    confirm()
    setSearchText(selectedKeys[0])
  }

  const handleReset = (clearFilters) => {
    clearFilters()
    setSearchText('')
  }

  const columns = [
    {
      title: 'No',
      key: 'No',
      render: (text, record, index) => <span>{index + 1}</span>
    },
    {
      title: 'ภาพ',
      dataIndex: 'imageUrl',
      key: 'imageUrl',
      render: (text, record) => (
        <a
          onClick={() => {
            setVisiblePreview(true)
            setPreviewImage(record.imageUrl)
          }}>
          View
        </a>
      )
    },
    {
      title: 'Email',
      key: 'email',
      dataIndex: 'email'
    },
    {
      title: 'Hero Type',
      key: 'heroType',
      dataIndex: 'heroType',
      render: (heroType) => <div>{HeroType[heroType].title}</div>
    },
    {
      title: 'Hero Name',
      key: 'name',
      dataIndex: 'name',
      ...getColumnSearchProps('name'),
      render: (name, row) => (
        <div>
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={name.toString()}
          />
        </div>
      )
    },
    {
      title: 'Tel',
      key: 'tel',
      dataIndex: 'tel'
    },
    {
      title: 'Get Brand Product',
      key: 'receive',
      dataIndex: 'receive',
      render: (text, record) => {
        let color
        switch (text) {
          case true:
            color = 'green'
            break
          case false:
            color = 'red'
            break
        }
        return (
          <Tag color={color} onClick={(e) => onClickRecieve(e, record)}>
            <a>
              {text ? 'ใช่' : 'ไม่'} &nbsp; <Icon type="edit" />
            </a>
          </Tag>
        )
      }
    },
    {
      title: 'หมายเหตุ',
      key: 'note',
      dataIndex: 'note',
      width: 220,
      render: (note, record) => (
        <a onClick={() => setNoteHero(record)}>
          <span
            title={note || ''}
            style={{
              display: 'inline-block',
              maxWidth: 170,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              verticalAlign: 'bottom'
            }}>
            {note || '-'}
          </span>
          &nbsp; <Icon type="edit" />
        </a>
      )
    },
    {
      title: 'Status',
      key: 'status',
      dataIndex: 'status',
      render: (text) =>
        text ? (
          <Tag color="green">Enabled</Tag>
        ) : (
          <Tag color="red">Disabled</Tag>
        )
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <span>
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => onDelete(record)}>
            <Button type="danger" size="small" shape="circle" icon="delete" />
          </Popconfirm>
        </span>
      )
    }
  ]

  async function onOk(heroId, receive) {
    const arr = []

    for (const item of brandHeroList) {
      arr.push({
        brandId: brandId,
        heroId: item.id,
        enable: true,
        receive: item.receive
      })
    }

    arr.push({
      brandId: brandId,
      heroId: heroId,
      receive: receive,
      enable: true
    })

    const data = {
      brandHeroRequests: arr,
      brandId: brandId
    }

    await dispatch(saveBrandHero(data))
    await dispatch(fetchBrandHero(brandId))
    await dispatch(getAllHeroes(filterOption))
    await setVisible(false)
    await setVisibleReceive(false)
  }


  async function onSaveNote(heroId, note) {
    const data = {
      brandHeroRequests: brandHeroList.map((item) => ({
        brandId: brandId,
        heroId: item.id,
        enable: true,
        receive: item.receive,
        ...(item.id === heroId ? { note } : {})
      })),
      brandId: brandId
    }

    await dispatch(saveBrandHero(data))
    await dispatch(fetchBrandHero(brandId))
    setNoteHero(null)
  }

  const onClick = async (e) => {
    e.preventDefault()
    setVisible(true)
  }

  const onDelete = async (record) => {
    const arr = []

    const results = brandHeroList.filter((item) => item.id !== record.id)
    for (const result of results) {
      arr.push({
        brandId: brandId,
        heroId: result.id,
        enable: true,
        receive: result.receive
      })
    }

    const data = {
      brandHeroRequests: arr,
      brandId: brandId
    }

    await dispatch(saveBrandHero(data))
    await dispatch(fetchBrandHero(brandId))
    await dispatch(getAllHeroes(filterOption))
  }

  const onCloseModal = () => {
    setVisible(false)
    setFormState(null)
  }

  const onClickRecieve = (e, record) => {
    e.preventDefault()
    setVisibleReceive(true)
    setFormData(record)
  }

  const onCloseModalRecieve = async () => {
    setFormData({})
    setVisibleReceive(false)
    await dispatch(fetchBrandHero(brandId))
    await dispatch(getAllHeroes(filterOption))
  }

  const HeaderTable = () => {
    return (
      <Row type="flex">
        <Col span={12}>
          <span>Hero List</span>
        </Col>
        <Col span={12}>
          <Row type="flex" justify="end">
            <ButtonEx
              color="#6ebf4b"
              type="primary"
              onClick={(e) => onClick(e)}>
              Add Hero
            </ButtonEx>
          </Row>
        </Col>
      </Row>
    )
  }

  return (
    <div>
      <PreviewImage
        imgUrl={previewImage}
        visible={visiblePreview}
        onClose={() => {
          setVisiblePreview(false)
          setPreviewImage(null)
        }}
      />
      <Table
        title={HeaderTable}
        loading={isLoading}
        bordered
        dataSource={brandHeroList}
        columns={columns}
        // pagination={{
        //   current: barcodeProductObj.pageable.pageNumber + 1,
        //   pageSize: barcodeProductObj.size,
        //   pageSizeOptions: ['10', '20', '50', '100'],
        //   showSizeChanger: true,
        //   onShowSizeChange: onShowSizeChange,
        //   onChange: onChange,
        //   total: barcodeProductObj.totalElements
        // }}
      />
      <BrandHeroForm
        formState={formState}
        brandId={brandId}
        visible={visible}
        onOk={onOk}
        onCancel={onCloseModal}
      />
      <BrandHeroNoteForm
        formData={noteHero || {}}
        visible={!!noteHero}
        loading={isLoading}
        onOk={onSaveNote}
        onCancel={() => setNoteHero(null)}
      />
      <BrandHeroReceiveForm
        formData={formData}
        visible={visibleReceive}
        onOk={onOk}
        onCancel={onCloseModalRecieve}
      />
    </div>
  )
}

export default BrandHero
